define('common/ko/deferreds',['knockout', 'common/ko/projections'], function(ko, addProjectionsFunctions) {

    ko.deferredComputed = function(evaluatorOrOptions, target, options) {
        options = options || {};

        if (typeof evaluatorOrOptions === 'object') {
            evaluatorOrOptions.deferEvaluation = true;
        } else {
            options.deferEvaluation = true;
        }

        return ko.computed(evaluatorOrOptions, target, options);
    };

    /**
     * See pureComputedEntity
     */
    ko.deferredComputedEntity = function(evaluatorOrOptions, target, options) {

        var entity = ko.deferredComputed(evaluatorOrOptions, target, options);

        entity.equalityComparer = function(a, b) {
            return a === b;
        };

        return entity;
    };

    ko.deferredComputedArray = function(evaluatorOrOptions, target, options) {
        var deferredComputedArray = ko.deferredComputed(evaluatorOrOptions, target, options).extend({ trackArrayChanges: true });
        addProjectionsFunctions(ko, deferredComputedArray);
        return deferredComputedArray;
    };

    ko.pureComputedArray = function(evaluatorOrOptions, target, options) {
        var pureComputedArray = ko.pureComputed(evaluatorOrOptions, target, options).extend({ trackArrayChanges: true });
        addProjectionsFunctions(ko, pureComputedArray);
        return pureComputedArray;
    };

    /**
     * Use this when the values are objects which can be compared with === to determine change.
     *
     * By default knockout will always recalculate objects which can lead to unexpected behaviour.
     */
    ko.pureComputedEntity = function(evaluatorOrOptions, target, options) {

        var entity = ko.pureComputed(evaluatorOrOptions, target, options);

        entity.equalityComparer = function(a, b) {
            return a === b;
        };

        entity.isEntity = true;

        return entity;
    };

    ko.subscribable.fn.toPureComputedArray = function() {
        return ko.pureComputedArray({
            read: this,
            write: this
        });
    };

});

